/**
 * 表单匹配项
 */
<template>
  <div class='form-item'>
    <custom-cascader 
      :size="size"
      v-if="isCustomSecLevelCascader"
      v-model="currentVal"
      v-bind="bindProps"
    />
    <el-input
      v-if="isInput"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      :size="size"
    ></el-input>
    <el-input
     v-if="isTextarea"
  type="textarea"
  v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      :size="size">
</el-input>

    <el-input-number
      v-if="isInputNumber"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      :controls-position="itemOptions['controls-position'] || 'right'"
      :size="size"
      
    ></el-input-number>
    <!-- 带分组的select -->
    <el-select v-if="isOptionGroupSelect" 
    @change="handleChange"
      v-model="currentVal" 
      clearable
      filterable
      :remote-method="remoteMethod"
      :loading="loading"
      :multiple="!!itemOptions.multiple"
      >
      <el-option-group v-for="group in list" :key="group.label" :label="group.label">
        <el-option
          v-for="item in group.options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-option-group>
    </el-select>
    <el-select
      v-if="isSelect"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      @focus="selectFocus"
      :size="size"
      clearable
      filterable
      :filter-method="selectfilterMethod"
     >
      <el-option
        v-for="item in filterList"
        :key="item.value"
        :label="itemOptions.config&&item[itemOptions.config.label]||item.label"
        :value="itemOptions.config&&item[itemOptions.config.value]||item.value"
      ></el-option>
    </el-select>

    <!-- datetimerange/daterange -->
    <el-date-picker
      v-if="isDatePickerDateRange"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      :type="itemOptions.elementType || 'datetimerange'"
      :size="size"
      clearable
      :picker-options="pickerOptionsRange"
      start-placeholder="开始日期"
      range-separator="至"
      end-placeholder="结束日期"
      :default-time="['00:00:00', '23:59:59']"
      value-format="yyyy-MM-dd HH:mm:ss"
    ></el-date-picker>

    <!-- monthrange -->
    <el-date-picker
      v-if="isDatePickerMonthRange"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      type="monthrange"
      :size="size"
      clearable
      :picker-options="pickerOptionsRangeMonth"
      start-placeholder="开始日期"
      range-separator="至"
      end-placeholder="结束日期"
      value-format="yyyy-MM"
    ></el-date-picker>

    <!-- others -->
    <el-date-picker
      v-if="isDatePickerOthers"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      :type="itemOptions.elementType"
      value-format="yyyy-MM-dd HH:mm:ss"
      :size="size"
      clearable
      placeholder="请选择日期"
    ></el-date-picker>

    <el-cascader
      v-if="isCascader"
      v-model="currentVal"
      v-bind="bindProps"
      v-on="bindEvents"
      :size="size"
      clearable
    ></el-cascader>
  </div>
</template>

<script>
import tools from './tools'
import CustomCascader from "./customSecLevelCascader.vue";
export default {
  inheritAttrs: false,
  components:{CustomCascader},
  props: {
    size:{
      type:String,
      default:'default'
    },
    value: {},
    itemOptions: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      pickerOptionsRange: tools.pickerOptionsRange,
      pickerOptionsRangeMonth: tools.pickerOptionsRangeMonth,
      loading:false,
      filterList:this.itemOptions.options
      
    }
  },
  methods: {
    selectFocus(data){
      this.filterList = this.itemOptions.options

    },
    selectfilterMethod(query){
      if(!query) {
        this.filterList = this.itemOptions.options
      }
      else{
        this.filterList = this.itemOptions.options.filter(item=>item.label.indexOf(query) !== -1)
      }
    },
    handleChangeCustomCascader(val){
      console.log('val: ', val);

    },
    handleChange(val){
      console.log('val: ', val);
      
    },
    remoteMethod(query){
      if(query == '') {
        this.list = []
      }
      this.loading = true
      let list = JSON.parse(JSON.stringify(this.itemOptions.options || []))
                  .filter(item=>{
                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
                  })
      this.list =list
      this.loading = false

    }
  },

  computed: {
    list(){
      return this.itemOptions.options || []
    },
    // 双向绑定数据值
    currentVal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    // 绑定属性
    bindProps () {
      let obj = { ...this.itemOptions }
      // 移除冗余属性
      delete obj.label
      delete obj.prop
      delete obj.type
      delete obj.initValue
      delete obj.rules
      delete obj.events
      if (obj.type === 'select') {
        delete obj.options
      }
      return obj
    },
    // 绑定方法
    bindEvents () {
      return this.itemOptions.events || {}
    },
    // input
    isInput () {
      return this.itemOptions.type === 'input'
    },
    isTextarea() {
      return this.itemOptions.type === 'textarea'
    },
    // custom-sec-level-cascader 自定义二级级联：一级单选 二级多选
    isCustomSecLevelCascader(){
      return this.itemOptions.type ==='custom-sec-level-cascader'
    },
    // input-number
    isInputNumber () {
      return this.itemOptions.type === 'input-number'
    },
    // select
    isSelect () {
      return this.itemOptions.type === 'select'
    },
    // option-group-select
    isOptionGroupSelect(){
      return this.itemOptions.type === 'option-group-select'
    },
    // date-picker (elementType: datetimerange/daterange)
    isDatePickerDateRange () {
      const isDatePicker = this.itemOptions.type === 'date-picker'
      const isDateRange = !this.itemOptions.elementType ||
        this.itemOptions.elementType === 'datetimerange' ||
        this.itemOptions.elementType === 'daterange'
      return isDatePicker && isDateRange
    },
    // date-picker (elementType: monthrange)
    isDatePickerMonthRange () {
      const isDatePicker = this.itemOptions.type === 'date-picker'
      const isMonthRange = this.itemOptions.elementType === 'monthrange'
      return isDatePicker && isMonthRange
    },
    //  date-picker (elementType: other)
    isDatePickerOthers () {
      const isDatePicker = this.itemOptions.type === 'date-picker'
      return isDatePicker && !this.isDatePickerDateRange && !this.isDatePickerMonthRange
    },
    // cascader
    isCascader () {
      return this.itemOptions.type === 'cascader'
    }
  },
  created () {},
}
</script>



// WEBPACK FOOTER //
// src/lib/formItem.vue